import { KeyValue } from "@/main/models/common";

export enum AffectedTypeTypes {
	GET_AFFECTED_TYPE = "@affectedType/GET_AFFECTED_TYPE",
	SAVE_AFFECTED_TYPE = "@affectedType/SAVE_AFFECTED_TYPE",
	RESET_REDUCER_AFFECTED_TYPE = "@affectedType/RESET_REDUCER_AFFECTED_TYPE",
}

export interface AffectedTypeState {
	readonly affectedType: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetAffectedType {
	type: typeof AffectedTypeTypes.GET_AFFECTED_TYPE;
}

export interface SaveAffectedType {
	type: typeof AffectedTypeTypes.SAVE_AFFECTED_TYPE;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerAffectedType {
	type: typeof AffectedTypeTypes.RESET_REDUCER_AFFECTED_TYPE;
}

export type AffectedTypeActionTypes = GetAffectedType | SaveAffectedType | ResetReducerAffectedType;
